<template>
    <div>
        <div class="form-group">
            <label class="form-control-label">Biosecurity:</label>
            <b-form-select v-model="data.isBiosecurity">
              <option value='true'>Yes</option>
              <option value='false'>No</option>
            </b-form-select>
        </div>
    </div>
</template>

<script>
import BaseAlert from '../BaseAlert.vue';
export default {
  name: 'form-sensor',
  components: {
    BaseAlert
  },
  props: {
    data: {
      type: Object,
      default: null,
    }
  }
};
</script>
